import { StorageKeysEnum } from '@/constants'
import adminRoutesForKs from '@/router/adminRoutesForKs'
import ChambautRoutesForKs from '@/router/ChambautRoutesForKs'
import pinia from '@/store'
import useUserStore from '@/store/user'
import { ElMessageBox } from 'element-plus'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { type RouteRecordRaw, createRouter, createWebHistory } from 'vue-router'
import adminRoutes from './adminRoutes'
import asyncRoutes from './asyncRoutes'
import asyncRoutesForFGYX from './asyncRoutesForFGYX'
import ChambautRoutes from './ChambautRoutes'
import constantsRoutes from './constantsRoutes'
import errorRoutes from './errorRoutes'
import secondPartnerRoutes from './secondPartnerRoutes'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [...constantsRoutes],
})

NProgress.configure({ showSpinner: false })

const userStore = useUserStore(pinia)

router.beforeEach(async (to, _from, next) => {
  NProgress.start()

  const token = localStorage.getItem(StorageKeysEnum.TOKEN)

  if (token) {
    if (to.path === '/login') {
      next('/')
    } else {
      if (userStore.routes.length > 0) {
        next()
      } else {
        const userInfo = await userStore.getUserInfo()

        if (userInfo) {
          // 动态添加抖音招商活动管理路由的函数
          const addPromotionActivityRoute = (routes: RouteRecordRaw[]) => {
            if (userInfo?.company?.allow_submit === 1) {
              return routes.map(route => {
                if (route.name === 'admin-super-panel' && route.children) {
                  const updatedChildren = [...route.children]
                  // 找到抖音数据统计分配路由的索引
                  const statisticalDistributionIndex = updatedChildren.findIndex(
                    child => child.name === 'tiktok-data-Statistical-distribution'
                  )
                  if (statisticalDistributionIndex !== -1) {
                    // 在抖音数据统计分配路由后添加抖音招商活动管理路由
                    updatedChildren.splice(statisticalDistributionIndex + 1, 0, {
                      path: 'tiktok-promotion-activity-management',
                      name: 'tiktok-promotion-activity-management',
                      meta: {
                        title: '抖音招商活动管理',
                      },
                      component: () =>
                        import(
                          '@/views/AdminSuperPanel/TiktokPromotionActivityManagement/index.vue'
                        ),
                    })
                  }
                  return { ...route, children: updatedChildren }
                }
                return route
              })
            }
            return routes
          }

          let accessedRoutes: RouteRecordRaw[] = [...asyncRoutes, ...errorRoutes]
          if (userInfo?.id === 10001 && userInfo?.company_id === 1) {
            const ChamRoutes = addPromotionActivityRoute([
              ...ChambautRoutes,
              ...adminRoutes,
              ...errorRoutes,
            ])
            ChamRoutes.forEach(route => router.addRoute(route))
            userStore.addRoutes(ChamRoutes)
            next({ ...to, replace: true })
          } else if (userInfo?.id === 10002 && userInfo?.company_id === 1) {
            const ChamRoutes = addPromotionActivityRoute([
              ...ChambautRoutesForKs,
              ...adminRoutesForKs,
              ...errorRoutes,
            ])
            ChamRoutes.forEach(route => router.addRoute(route))
            userStore.addRoutes(ChamRoutes)
            next({ ...to, replace: true })
          } else if (userInfo?.company_id === 1) {
            accessedRoutes = addPromotionActivityRoute([
              ...asyncRoutes,
              ...adminRoutes,
              ...errorRoutes,
            ])
            accessedRoutes.forEach(route => router.addRoute(route))
            userStore.addRoutes(accessedRoutes)
            next({ ...to, replace: true })
          } else if (userInfo?.company_id === 1424) {
            // 为 company_id === 1424 配置特定路由权限（发哥严选）
            accessedRoutes = addPromotionActivityRoute([...asyncRoutesForFGYX, ...errorRoutes])
            accessedRoutes.forEach(route => router.addRoute(route))
            userStore.addRoutes(accessedRoutes)
            next({ ...to, replace: true })
          } else if (userInfo?.company_id === 1600) {
            // 为 company_id === 1600 配置特定路由权限（二级团 - 只显示活动提报工具和公司活动管理）
            accessedRoutes = [...secondPartnerRoutes, ...errorRoutes]
            accessedRoutes.forEach(route => router.addRoute(route))
            userStore.addRoutes(accessedRoutes)
            next({ ...to, replace: true })
          } else {
            // accessedRoutes = [...accessedRoutes, ...errorRoutes];
            accessedRoutes = addPromotionActivityRoute(accessedRoutes)
            accessedRoutes.forEach(route => router.addRoute(route))
            userStore.addRoutes(accessedRoutes)
            next({ ...to, replace: true })
          }
        } else {
          ElMessageBox.confirm('请重新登录！', '注意', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              userStore.resetToken()
              next({ path: '/login', query: { redirect: to.fullPath } })
              NProgress.done()
            })
            .catch(() => {
              NProgress.done()
            })
        }
      }
    }
  } else {
    if (to.path === '/login') {
      next()
    } else {
      next({ path: '/login', query: { redirect: to.fullPath } })
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})

export const removeRoutes = (routes: RouteRecordRaw[]) => {
  routes.forEach(route => router.removeRoute(route.name as string))
}

export default router
